import { APICore } from 'helpers/api/apiCore'

const api = new APICore()

export function getQuantidadeLeads() {
  return api.get(`Atendimento/leads`, null)
}

export function iniciarAtendimentoLead() {
  return api.create(`Atendimento/iniciar-atendimento-lead`, null)
}

export function getCarteiras() {
  return api.get(`Home/carteiras`, null)
}

export function iniciarAtendimentoCarteiras(
  tipoProduto: number,
  consultorId: string
) {
  return api.create(`Atendimento/iniciar-atendimento-carteira`, {
    tipoProduto,
    consultorId
  })
}

export function getCampanhas() {
  return api.get(`Home/campanhas`, null)
}

export function iniciarAtendimentoCampanhas(campanhaCrmId: string) {
  return api.create(`Atendimento/iniciar-atendimento-campanha`, {
    campanhaCrmId
  })
}

export function getBigNumbers(dataAgendamentos: string) {
  return api.get(`Agenda/big-numbers`, {
    dataAgendamentos
  })
}

export function ativarCampanha(campanhaId: string) {
  return api.get(`Discador/start-campanha`, {
    campanhaId
  })
}

export function desativarCampanha(campanhaId: string) {
  return api.get(`Discador/pause-campanha`, {
    campanhaId
  })
}

export function getCentrosCustosCarteira() {
  return api.get(`Home/carteiras-centros-custo`, null)
}

export function getConsultoresCarteiraByCentroCusto(centroCustoId: string) {
  return api.get(`Home/carteiras-consultores/${centroCustoId}`, null)
}

export function getCarteiraByConsultor(
  consultorId: string,
  centroCustoId: string
) {
  return api.get(`Home/carteiras/${consultorId}/${centroCustoId}`, null)
}
